import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/pastDuePerformanceSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();

  const dateFormat = useDateFormat();

  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.pastDuesPerformance.currentUser
  );

  const { startDate, endDate } = useSelector((state) => state.pastDuesPerformance.selectedFilters);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      showDefaultInputIcon={false}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};

export default DatePicker;
